/* Shopify Forms owns submission and validation. This only adds order-number guidance. */
if (!customElements.get('swe-warranty-page')) {
  customElements.define('swe-warranty-page', class extends HTMLElement {
    connectedCallback() {
      this.attempts = 0;
      this.connectForm();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
    }

    connectForm() {
      if (!this.isConnected) return;
      const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
      if (!root) {
        // The visible account callout remains useful if the app never loads.
        if (this.attempts++ < 120) this.timer = setTimeout(() => this.connectForm(), 250);
        return;
      }
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.addOrderHint(root));
      this.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['placeholder', 'aria-describedby'] });
      this.addOrderHint(root);
    }

    addOrderHint(root) {
      const input = root.querySelector('input[id="custom#order_number"]');
      if (!input) return;
      if (!root.querySelector('#swe-order-hint-style')) {
        const style = document.createElement('style');
        style.id = 'swe-order-hint-style';
        style.textContent = `
          input[id="custom#order_number"] { padding: 24px 14px 8px !important; min-height: 60px !important; box-sizing: border-box !important; }
          input[id="custom#order_number"]::placeholder { color: #64685f; opacity: 1 !important; }
          label[for="custom#order_number"] { top: 6px !important; transform: none !important; font-size: 12px !important; }
          [data-testid="date-birthday"] label { white-space: nowrap; }
          #swe-order-number-hint { display: block; margin: 8px 0 0; font-size: 12px; line-height: 1.5; color: #595f55; }
        `;
        root.append(style);
      }
      if (input.placeholder !== this.dataset.orderExample) input.placeholder = this.dataset.orderExample;
      let hint = root.querySelector('#swe-order-number-hint');
      if (!hint) {
        hint = document.createElement('small');
        hint.id = 'swe-order-number-hint';
        hint.textContent = this.dataset.orderHint;
        input.parentElement.append(hint);
      }
      const describedBy = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      if (!describedBy.has(hint.id)) {
        describedBy.add(hint.id);
        input.setAttribute('aria-describedby', [...describedBy].join(' '));
      }
    }
  });
}
